import { useAtomValue } from 'jotai';
import { $PageLevelTraffic } from 'shared/atoms';
import { $CurrentArticle } from '@article/shared/atoms/current-article';
import { useMemo } from 'react';
import {
  ArticleDetailUtil,
  EArticleClass,
  IGalleryArticleDetail,
  IRichArticleDetail,
  IVideoArticleDetail,
} from 'shared/models';
import { useArticleTitle } from '@article/shared/utils/use-article-title';
import { useArticleDescription } from '@article/shared/utils/use-article-description';

export const ArticleOpenGraph = () => {
  const { canonicalUrl } = useAtomValue($PageLevelTraffic);
  const article = useAtomValue($CurrentArticle);

  const title = useArticleTitle();
  const description = useArticleDescription();

  const imageMeta = useMemo(() => {
    if (!ArticleDetailUtil.isArticleAvailable(article)) {
      return null;
    }
    const { articleClass } = article;
    if (articleClass === EArticleClass.GALLERY) {
      return (article as IGalleryArticleDetail).imageList[0];
    }
    return (article as IVideoArticleDetail | IRichArticleDetail).largeImage;
  }, []);

  return (
    <>
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content="article" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {imageMeta && (
        <>
          <meta property="og:image:type" content={imageMeta.url.endsWith('.webp') ? 'image/webp' : 'image/jpeg'} />
          <meta property="og:image" content={imageMeta.url} />
          <meta property="og:image:width" content={String(imageMeta.width)} />
          <meta property="og:image:height" content={String(imageMeta.height)} />
        </>
      )}
    </>
  );
};
